export default {
  estimate: "estimate",
  date: "date",
};
